import "core-js/modules/es.object.to-string.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "activity-container"
  }, [_c("van-pull-refresh", {
    on: {
      refresh: _vm.onRefresh
    },
    model: {
      value: _vm.isLoading,
      callback: function callback($$v) {
        _vm.isLoading = $$v;
      },
      expression: "isLoading"
    }
  }, [_vm.activityData.length > 0 ? _c("van-list", {
    attrs: {
      finished: _vm.finished,
      "finished-text": _vm.$t("NoMoreContents")
    },
    on: {
      load: _vm.onLoad
    },
    model: {
      value: _vm.loading,
      callback: function callback($$v) {
        _vm.loading = $$v;
      },
      expression: "loading"
    }
  }, _vm._l(_vm.activityData, function (item, index) {
    return _c("van-cell", {
      key: index,
      staticClass: "item",
      on: {
        click: function click($event) {
          return _vm.toDetail("activity", item.threadId);
        }
      }
    }, [_c("div", {
      staticClass: "img-con"
    }, [Object.prototype.toString.call(item["content"]["indexes"]) == "[object Object]" && item["content"]["indexes"]["101"]["body"].length > 0 ? _c("van-image", {
      attrs: {
        fit: "cover",
        src: item["content"]["indexes"]["101"]["body"][0].thumbUrl
      }
    }) : _vm._e(), _c("div", {
      staticClass: "title-con"
    }, [!item.activity_registration ? _c("span", {
      staticClass: "join",
      on: {
        click: function click($event) {
          $event.stopPropagation();
          return _vm.toSign(1, item.threadId, item);
        }
      }
    }, [_vm._v(_vm._s(_vm.$t("Signingup")))]) : _vm._e(), item.activity_registration ? _c("span", {
      staticClass: "noJoin",
      on: {
        click: function click($event) {
          $event.stopPropagation();
          return _vm.toSign(0, item.threadId, item);
        }
      }
    }, [_vm._v("registered")]) : _vm._e(), _c("span", {
      domProps: {
        textContent: _vm._s(item.title)
      }
    })])], 1), item.position.address ? _c("div", {
      staticClass: "position"
    }, [_c("img", {
      attrs: {
        src: require("../../../assets/images/Location.png"),
        alt: ""
      }
    }), _c("span", [_vm._v(_vm._s(item.position.address))])]) : _vm._e(), item.start_at || item.end_at ? _c("div", {
      staticClass: "time"
    }, [_c("img", {
      attrs: {
        src: require("../../../assets/images/Time.png"),
        alt: ""
      }
    }), _c("span", [_vm._v(_vm._s(item.start_at) + " - " + _vm._s(item.end_at))])]) : _vm._e()]);
  }), 1) : _vm._e()], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };